<template>
  <div class="download-app-dialog">
    <div class="close-btn" @click="closeDialog">
      <img src="../../assets/img/components/dialogComponent/close_btn.png" alt="关闭">
    </div>
    <div class="content-text">
      请前往启航APP内查看哦~
    </div>
    <div class="download-btn" @click="downloadApp">
      打开APP
    </div>
  </div>
</template>

<script>
export default {
  name: 'downloadApp',
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    downloadApp() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'https://itunes.apple.com/cn/app/id1172161344';
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      } else {
        const loadDateTime = Date.now();
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'iqihanglmh5://';
          const turnIOS = setTimeout(() => {
            const timeOutDateTime = Date.now();
            if (timeOutDateTime - loadDateTime < 2200) {
              window.location.href = 'https://itunes.apple.com/cn/app/id1172161344';
            } else {
              clearTimeout(turnIOS);
            }
          }, 2000);
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.download-app-dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 610px;
  height: 405px;
  overflow: hidden;
  background: #FFF;
  border-radius: 20px;
  .close-btn {
    img {
      position: absolute;
      top: 41px;
      right: 41px;
      width: 40px;
      height: 40px;
    }
  }
  .content-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 70%;
    font-size: 30px;
  }
  .download-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 67px;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    background: #ff6c02;
    border-radius: 34px;
  }
}
</style>
